import { render, staticRenderFns } from "./CustomersPerMonthChart.vue?vue&type=template&id=133d9342"
import script from "./CustomersPerMonthChart.vue?vue&type=script&lang=js"
export * from "./CustomersPerMonthChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports